import { GOTO_CRITICAL_BANNER_NOTIFICATION_SELECTOR } from '../../common/container'
import { createMacOSSupportBannerElement, getDocument } from '../../common/dom-helpers'
export class MacOSSupportBannerService {
  private macOSSupportBannerElement: HTMLElement | undefined

  show() {
    if (!this.macOSSupportBannerElement) {
      this.macOSSupportBannerElement = createMacOSSupportBannerElement()
    }
    const criticalBannerContainer = getDocument().querySelector(GOTO_CRITICAL_BANNER_NOTIFICATION_SELECTOR)
    criticalBannerContainer?.setAttribute('style', 'height:32px;')
    criticalBannerContainer?.appendChild(this.macOSSupportBannerElement)
  }

  hide() {
    if (this.macOSSupportBannerElement) {
      this.macOSSupportBannerElement.remove()
      const criticalBannerContainer = getDocument().querySelector(GOTO_CRITICAL_BANNER_NOTIFICATION_SELECTOR)
      if (!criticalBannerContainer?.childNodes?.length) {
        criticalBannerContainer?.removeAttribute('height')
      }
    }
  }
}
